module.exports = __webpack_public_path__ + "static/media/dormitorio-2.1a79bb14.jpg";